import {Component, computed, effect, inject, input, output, signal} from '@angular/core';
import {Select} from 'primeng/select';
import {TooltipModule} from 'primeng/tooltip';
import {FormsModule} from '@angular/forms';
import {Card} from 'primeng/card';
import {TranslocoPipe} from '@jsverse/transloco';
import {HostingLocationService} from '@frontend/shared';
import {HostingLocation} from '@frontend/directus';
import {ProjectStepSaveButtonComponent} from '../../../../../../../shared/project-step-save-button/project-step-save-button.component';

@Component({
  selector: 'app-hosting-provider-tab',
  imports: [
    Select,
    TooltipModule,
    FormsModule,
    Card,
    ProjectStepSaveButtonComponent,
    TranslocoPipe,
  ],
  templateUrl: './step-1-3-hosting-provider-tab.component.html',
})
export class Step13HostingProviderTabComponent {
  private readonly hostingLocationService = inject(HostingLocationService);

  readonly selectedLocation = signal<string | null>(null);
  readonly originalLocation = input<string | null>(null);
  readonly isSaving = input(false);
  readonly disabled = input<boolean>(false);

  readonly submitOutput = output<{hostingProviderLocation: string}>();

  readonly locations = this.hostingLocationService.getHostingLocations();

  readonly hasChanges = computed(() => {
    const original = this.originalLocation();
    const current = this.selectedLocation();

    if (original === null) {
      return current !== null;
    }

    return original !== current;
  });

  readonly shouldShowSaveButton = computed(() => {
    return this.hasChanges() && this.selectedLocation();
  });

  constructor() {
    effect(() => {
      const original = this.originalLocation();
      this.selectedLocation.set(original);
    });
  }

  onLocationChange(countryCode: string | null): void {
    this.selectedLocation.set(countryCode);
  }

  onSubmit(): void {
    const location = this.selectedLocation();
    if (location) {
      this.submitOutput.emit({hostingProviderLocation: location});
    }
  }

  hasFlag(location: HostingLocation): boolean {
    return location.type === 'country' || location.isoCode === 'EU';
  }

  getCountryFlagUrl(countryCode: string): string {
    return this.hostingLocationService.getHostingLocationFlagUrl(countryCode);
  }

  getLocationIconClass(location: HostingLocation): string {
    return this.hostingLocationService.getHostingLocationIconClass(location);
  }

  getLocationDisplayName(location: HostingLocation): string {
    return this.hostingLocationService.getHostingLocationDisplayName(location);
  }
}
